// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__GtbmN","spin":"spinner_spin__2LPBO","simulator":"spinner_simulator__pK9LZ"};